import gql from 'graphql-tag';
export const getProductsDataUnrestricted = gql`
  query GetAllProductsDataUnrestricted {
    productsAllUnrestricted {
      id
      name
      barcode
      code
      stockQuantity
      measurementUnit
      wholesalePrice
      retailPrice
      price
      discount1
      discount2
      decimal
      quantityUnit
      packaging
      weight
      tarifnaGrupa
      color
      colorDescription
      division
      brand
      category
      parentCategory
      categoryCode
      parentCategoryCode
      isPos
      isTobacco
      supplier
      eans {
        id
        ean
      }
    }
    suppliers {
      id
      name
      code
    }
    customersCategories {
      id
      product
      category
    }
    hierarchicalCategoriesUnrestricted {
      id
      name
      code
      childrens {
        id
        name
        code
        childrens {
          id
          name
          code
          childrens {
            id
            name
            code
            childrens {
              id
              name
              code
              childrens {
                id
                name
                code
              }
            }
          }
        }
      }
    }
    productStocksUnrestricted
    productGroups
    productSpecCategories
    productDeliveryHistoryByUser
  }
`;